@if (campaignType === CampaignType.Reward) {
  <div mat-dialog-content>
    <div fxLayout="column" fxLayoutAlign="center start">
      <span>
        NOTE: The Spotlight Duplicate Reward Check is performed automatically regardless of active reward inclusion or exclusion.
        This check prevents the same reward, for the same duration, being loaded on the same Customer account.
        @if (!fromDiscover) {
          <span>This check is bypassed if either the <b>Sorry for the snag</b> or <b>We apologize</b> reward themes on Engage is selected for recovery effort.</span>
        }
      </span>
      <div class="confirmation__divider"></div>
    </div>
    <b>Reward Summary</b>
    <br>
      <div class="confirmation__reward-summary">
        <div>
          TBD customer(s)
        </div>
        {{rewardLength}} day(s), expiring on {{endDate | locTimeZoneDate:'MMM DD, YYYY'}}.
      </div>
      <br>
        <b><i>
          <span>When immediately sending a reward, you can NOT cancel the offer after it is sent.</span>
          @if (!fromDiscover) {
            <span>Only a reward scheduled to send on a future date may be cancelled, prior to the start date, from Spotlight Calendar.</span>
          }
        </i></b>
      </div>
    }
    @if (campaignType === CampaignType.Automation) {
      <div mat-dialog-content>
        <div style="padding: 30px 30px 0 30px; font-size: 15px;">
          {{confirmationText}}
        </div>
      </div>
    }
    @if (campaignType != CampaignType.Reward && campaignType != CampaignType.Automation) {
      <div mat-dialog-content>
        @if (groupNow) {
          <div style="padding: 30px 30px 0 30px; font-size: 15px;">
            You've selected {{count}} customer(s) to receive this communication. Would you like proceed?
          </div>
        }
        @if (!groupNow) {
          <div style="padding: 30px 30px 0 30px; font-size: 15px;">
            Your campaign will be sent to Customers in the selected group(s) at scheduled send time. Would you like to proceed?
          </div>
        }
      </div>
    }
    <div mat-dialog-actions class="confirmation__wrapper">
      <button mat-button class="confirmation__cancel-button"
        (click)="closeDialog(false)" >
        Cancel
      </button>
      <button mat-button
        (click)="closeDialog(true)"
        [disabled]="sendDisabled(count, campaignType)"
        [ngClass]="{
        'confirmation__send-button': !sendDisabled(count, campaignType),
        'confirmation__send-button-disabled': sendDisabled(count, campaignType)
        }">
        Send
      </button>
    </div>

